// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sw5lY8500WfpLJ {
  border: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emojiButton": `sw5lY8500WfpLJ`
};
export default ___CSS_LOADER_EXPORT___;
